import React, { useState, useEffect } from 'react';
import { FiAward } from "react-icons/fi";
import '../styles/Research.css';

const DEFAULT_RESEARCHERS = [
  { id: 1, name: "Prof. Ahmed Alami", title: "Directeur de Recherche", countryCode: "ma", country: "Maroc", company: "Université Mohammed V", company_logo: "", image: "" },
  { id: 2, name: "Dr. Marie Lefebvre", title: "Chercheuse Senior", countryCode: "fr", country: "France", company: "CNRS", company_logo: "", image: "" },
  { id: 3, name: "Prof. John Smith", title: "Expert en Cyber-sécurité", countryCode: "us", country: "USA", company: "MIT", company_logo: "", image: "" },
  { id: 4, name: "Dr. Fatima Zahra", title: "Spécialiste IA", countryCode: "ae", country: "UAE", company: "Khalifa University", company_logo: "", image: "" },
  { id: 5, name: "Prof. Liu Wei", title: "Technologies Emergentes", countryCode: "cn", country: "Chine", company: "Tsinghua University", company_logo: "", image: "" },
  { id: 6, name: "Dr. Andrea Rossi", title: "Droit du Numérique", countryCode: "it", country: "Italie", company: "Università di Bologna", company_logo: "", image: "" },
];

export default function ResearchCommittee() {
  const [researchersList, setResearchersList] = useState(DEFAULT_RESEARCHERS);

  useEffect(() => {
    try {
      const saved = localStorage.getItem('iamar_research_committee_data');
      if (saved) {
        setResearchersList(JSON.parse(saved));
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  return (
    <div className="research-page">
      <div className="research-header-banner research-banner">
         <div className="banner-overlay">
            <span className="banner-tag">EXCELLENCE ACADÉMIQUE</span>
            <h1>Comité Scientifique</h1>
            <p>Un conseil d'experts académiques garantissant la rigueur et l'innovation de nos travaux de recherche</p>
         </div>
      </div>

      <div className="research-content-container">
        <div className="section-header-v2">
           <span className="accent-line"></span>
           <h3>Membres du Comité</h3>
        </div>
        
        <div className="research-grid">
           {researchersList.map(r => (
             <div className="research-card" key={r.id}>
                <div className="research-media">
                   {r.image ? (
                     <img src={r.image} alt={r.name} />
                   ) : (
                     <div style={{ width: '100%', height: '100%', minHeight: 260, background: '#1e293b', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8' }}>
                       <FiAward size={48} />
                     </div>
                   )}
                   {r.countryCode && (
                     <div className="research-flag-box">
                        <img 
                          src={`https://flagcdn.com/72x54/${r.countryCode}.png`} 
                          alt={r.country} 
                          className="api-flag-v2"
                        />
                     </div>
                   )}
                </div>
                <div className="research-info">
                   <h4>{r.name}</h4>
                   <p className="research-title-v2">{r.title}</p>
                   
                   <div className="research-meta-blueprint">
                      <div className="meta-left">
                         {r.company_logo && <img src={r.company_logo} alt={r.company} className="company-logo-img" />}
                         <span className="company-text">{r.company || r.country}</span>
                      </div>                  
                   </div>
                </div>
             </div>
           ))}
        </div>
      </div>
    </div>
  );
}
